import i18next from "i18next";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateAccepted = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const t = i18next.getFixedT(null, "admin");
  const needsOrderTypeItem = selectedOrder && selectedOrder.isFromCuo === "CUO" && selectedOrder.orderTypeItem === "Specjalne";

  const realizationBtn = needsOrderTypeItem ? {
    key: "check out",
    text: t("orders.commandBar.assignVehicleTypeInSplits"),
    iconProps: { iconName: "Warning" },
    disabled: true,
  } : {
    key: "check out",
    text: t("orders.commandBar.realize"),
    iconProps: { iconName: "BusSolid" },
    onClick: actions.pushToRealization,
  };

  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" ? [{
    key: "cuoSplits",
    text: t("orders.commandBar.manageCuoSplits"),
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return []
    case Quantity.ONE:
      return [
        {
          key: "add",
          text: t("orders.commandBar.see"),
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "edit",
          text: t("orders.commandBar.edit"),
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        realizationBtn,
        {
          key: "delete",
          text: t("orders.commandBar.cancelOrder"),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    case Quantity.MANY:
      return [realizationBtn, {
        key: "delete",
        text: t("orders.commandBar.cancelOrder"),
        iconProps: { iconName: "delete" },
        name: "delete",
        onClick: actions.setOrderCanceled,
      },];
  }
};
